module.exports = __webpack_public_path__ + "static/media/file_copy-24px.d2b823bb.svg";